import { Navbar, Nav, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import React from 'react';
// id={isHovering ? 'gnb active' : 'gnb'}
const Sub_header = () => {
    return (
        <Container >
            <Navbar>
                <Nav className="py-2 spacing">
                    <div id="sub_nav" className="text-center">
                        <div>
                            <Row>
                                <Link to={"/about/company"} className="text-md py-2">
                                    <div id="menu">기업소개</div>
                                </Link>
                                <Link to={"/about/hiearchy"} className="text-md py-2">
                                    <div id="menu">조직도</div>
                                </Link>
                                <Link to={"/about/location"} className="text-md py-2">
                                    <div id="menu">오시는길</div>
                                </Link>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Link to={"/products"} className="text-md py-2">
                                    <div id="menu">품목</div>
                                </Link>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Link to={"/business/client"}className="text-md py-2">
                                    <div id="menu">고객사</div>
                                </Link>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Link to={"/inquiry"} className="text-md py-2">
                                    <div id="menu">온라인문의</div>
                                </Link>
                            </Row>
                        </div>
                    </div>
                    <div id="mobile_menu" className="text-center">
                        <div className="py-3 w-full">
                            <Link to={"/about/company"} className="text-lg py-2 font-semibold">
                                <div>기업소개</div>
                            </Link>
                        </div>
                        <div className="py-3">
                            <Link to={"/about/hiearchy"} className="text-lg py-2 font-semibold">
                                <div>조직도</div>
                            </Link>
                        </div>
                        <div className="py-3">
                            <Link to={"/about/location"} className="text-lg py-2 font-semibold">
                                <div>오시는길</div>
                            </Link>
                        </div>
                        <div className="py-3">
                            <Link to={"/products"} className="text-lg py-2 font-semibold">
                                <div>품목</div>
                            </Link>
                        </div>
                        <div className="py-3">
                            <Link to={"/business/client"}className="text-lg py-2 font-semibold">
                                <div>고객사</div>
                            </Link>
                        </div>
                        <div className="py-3">
                            <Link to={"/inquiry"} className="text-lg py-2 font-semibold">
                                <div>온라인문의</div>
                            </Link>
                        </div>
                    </div>
                </Nav>
            </Navbar>
        </Container>
    )
}

export default Sub_header
